import  { useState, useEffect } from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import OurStore from "./pages/OurVehicles";
  
 import SingleProduct from "./pages/SingleProduct";
  
 import { useDispatch } from 'react-redux';
 
  
import logo from "./images/logos/z-logo-circle.png"
 import TypePage from './pages/TypePage';
import BrandsPage from './pages/BrandsPage';
import AllBrandsPage from './pages/AllBrandsPage';
import SearchPage from './pages/SearchPage';
import Sellcar from './pages/Sellcar';
import Vehicles from './pages/Vehicles';
import ScrollToTop from './components/ScrollToTop';
import Clients from './pages/Clients';
import OurVehicles from './pages/OurVehicles';
import Usage from './pages/Usage';
import LoanCalculator from './pages/LoanCalculator';
import { Spiral } from 'ldrs/react'
import 'ldrs/react/Spiral.css'
import NotFound from './pages/NotFound';
import Blogs from './pages/Blogs';
import SingleBlog from './pages/singleBlog';
import { Hourglass } from 'ldrs/react'
import 'ldrs/react/Hourglass.css'

import { Infinity } from 'ldrs/react'
import 'ldrs/react/Infinity.css'
import PrivacyPolicy from './pages/PrivacyPrivacy';
import TermsAndConditions from './pages/TermsAndConditions';
import FAQs from './pages/FAQs';
import Enroute from './pages/Enroute';
 import 'ldrs/react/Hourglass.css'
import ImportGuide from './pages/ImportGuide';
import Financing from './pages/Financing';

 
 
function App() {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
    useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 500);
  
    return () => clearTimeout(timeout);
  }, []);
  

 
  

{/*  useEffect(() => {
    const handleContextMenu = (event) => {
      event.preventDefault();  // Disable right-click
    };

    const handleCopy = (event) => {
      event.preventDefault();  // Disable copy
    };

    const handleSelectStart = (event) => {
      event.preventDefault();  // Disable text selection
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('copy', handleCopy);
    document.addEventListener('selectstart', handleSelectStart);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('copy', handleCopy);
      document.removeEventListener('selectstart', handleSelectStart);
    };
  }, []);*/}
  
  return (
    <>
      <BrowserRouter>

      {loading ? (
        <div className="loader position-relative ">





 <Hourglass
  size="40"
  bgOpacity="0.1"
  speed="1.75"
  color="black" 
/>
         
        </div>
     ) : (
        <>
        <ScrollToTop/>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about-us" element={<About />} />
  
            <Route path="contact-us" element={<Contact />} />
            <Route path="warehouse" element={<OurVehicles />} />
            <Route path="search" element={<SearchPage />} />
             <Route path="vehicles" element={<Vehicles />} />
             <Route path="import-guide" element={<ImportGuide />} />
              <Route path="financing" element={<Financing />} />
            <Route path="vehicle/:slug" element={<SingleProduct />} />
             <Route path="/:type/brand/:brand" element={<BrandsPage />} />
           <Route path="/:type" element={<TypePage />} />
           <Route path="/brand/:brand" element={<AllBrandsPage />} />
           <Route path="imports" element={<Sellcar />} />
            <Route path="/clients" element={<Clients/>}/>
            <Route path="usage/:usage" element={< Usage />} />
            <Route path="loan-financing/:slug" element={< LoanCalculator />} />
            <Route path='blogs' element={<Blogs/>}/>
            <Route path='privacy-policy' element={<PrivacyPolicy/>}/>
             <Route path='terms-and-conditions' element={<TermsAndConditions/>}/>
            <Route path='faqs' element={<FAQs/>}/>
 
             <Route path='enroute' element={<Enroute/>}/>

            <Route path='blogs/:slug' element={<SingleBlog/>}/>
            <Route path="*" element={< NotFound/>} />

          </Route>
  

   
    
        </Routes>
          </>
        )}
      </BrowserRouter>
    </>
  );
}

export default App;
